// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressBlockStyle } from "@hardwoods/App/WidgetExtensions/MyAccountPagesSharedStyle/DetailsPages/AddressBlockStyle";
import { orderInfoStyle } from "@hardwoods/App/WidgetExtensions/MyAccountPagesSharedStyle/DetailsPages/OrderInfoStyle";
import { requestRmaInformationStyles } from "@hardwoods/Overrides/Widgets/RequestRma/RequestRmaInformation";
import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import { css } from "styled-components";

requestRmaInformationStyles.mainWrapper = {
    css: css`
        display: flex;
        ${xScreen.lte("sm")} {
            flex-direction: column;
        }
    `,
};

requestRmaInformationStyles.wrapper = {
    css: css`
        width: 50%;
        padding-right: 15px;
        display: flex;
        flex-direction: column;
        padding-bottom: 30px;

        ${xScreen.lte("sm")} {
            width: 100%;
            padding-right: 0;
        }
    `,
};

requestRmaInformationStyles.fieldWrapper = orderInfoStyle.orderWrapper;

requestRmaInformationStyles.titleText = orderInfoStyle.orderLabel;

requestRmaInformationStyles.orderDateText = orderInfoStyle.orderValue;

requestRmaInformationStyles.customerPOText = orderInfoStyle.orderValue;

requestRmaInformationStyles.orderNumberText = orderInfoStyle.orderValue;

requestRmaInformationStyles.billingInformationGridItem = {
    css: css`
        ${addressBlockStyle.wrapper!.css}
        width: 50%;
        padding-left: 15px;
        padding-bottom: 30px;

        ${xScreen.lte("sm")} {
            width: 100%;
            padding-left: 0;
        }
    `,
};

requestRmaInformationStyles.billingInformationTitleText = addressBlockStyle.titleText;
